import { render, staticRenderFns } from "./ItemContent.vue?vue&type=template&id=51389d04&scoped=true"
import script from "./ItemContent.vue?vue&type=script&lang=ts"
export * from "./ItemContent.vue?vue&type=script&lang=ts"
import style0 from "./ItemContent.vue?vue&type=style&index=0&id=51389d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51389d04",
  null
  
)

export default component.exports